import ListaLeads from '../componentes/ListaLeads'

const routes = [
  ...route('/lista-clientes-potenciales', ListaLeads, {
    auth: true,
    require_consultant_handy_package: true
  }),
]

function route(path, component = Default, meta = {}, props = true) {
  return [{
    path,
    component,
    meta,
    props
  }]
}

export default routes